import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { link } from 'chaoskit/src/assets/styles/utility'

import Data from '~components/Data'
import TextLink from '~components/TextLink'
import Image from '~components/Image'

// Supports both local-queried and Algolia-sourced case study teasers
export default function TeaserCard({ data, title }) {
  const theme = useTheme()

  return (
    <TextLink
      href={`${data.slug}${data.contentId ? `#${data.contentId}` : ''}`}
      css={[
        link.reset(theme),
        {
          borderTopLeftRadius: theme.borderRadius.base,
          borderTopRightRadius: theme.borderRadius.base,
          position: 'relative',
          zIndex: 1,

          '&::after': {
            content: "''",
            zIndex: -1,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 240,
            background: `linear-gradient(${theme.color.light.base}, ${theme.brand.darkViolet}, ${theme.color.light.base})`,
            opacity: theme.opacity.base / 2,
            filter: 'blur(4px)',
            willChange: 'filter',
            transition: `filter ${theme.timing.base} ${theme.transition.base}`,
          },

          '&:hover, &:focus': {
            '&::after': {
              filter: 'blur(8px)',
              opacity: theme.opacity.base,
            },
          },
        },
      ]}
    >
      <div
        css={{
          height: 0,
          paddingBottom: '50%',
          background: theme.color.dark.base,
          position: 'relative',
          borderTopLeftRadius: theme.borderRadius.base,
          borderTopRightRadius: theme.borderRadius.base,
          overflow: 'hidden',
        }}
      >
        <Image
          src={data.featuredImage}
          css={{
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectPosition: 'right bottom',
          }}
        />
      </div>

      <div
        css={{ padding: theme.space.base, background: theme.color.light.base }}
      >
        <div
          css={{
            ...theme.text.large,
            fontWeight: theme.fontWeight.bold,
            margin: 0,
          }}
        >
          {title}
        </div>
        <div css={{ marginTop: theme.space.small }}>
          <Data>{data.excerpt}</Data>
        </div>
      </div>
    </TextLink>
  )
}

TeaserCard.propTypes = {
  data: PropTypes.shape({
    contentId: PropTypes.string,
    slug: PropTypes.string.isRequired,
    excerpt: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    featuredImage: PropTypes.string.isRequired,
  }),
  title: PropTypes.any.isRequired,
}
